import { addSectorTotals, calculateMix, summarize } from "./data";

const getMixData = (database, data) => {
  data = addSectorTotals(data).map(datum => ({
    ...datum,
    sector: database.sectors[datum.sector],
    method: database.methods[datum.method]
  }));

  const methodTotals = summarize(
    data.filter(datum => ["Public", "Private"].includes(datum.sector)),
    ["method"]
  ).map(datum => ({
    ...datum,
    sector: "Total"
  }));

  data = [...data, ...methodTotals];

  const sectorTotals = summarize(data, ["sector"]).map(datum => ({
    ...datum,
    method: "Total"
  }));

  data = [...data, ...sectorTotals];

  return calculateMix(data, "method", "sector", "Total").map(datum => ({
    ...datum,
    sector: `${datum.sector} (Mix)`
  }));
};

const getShareData = (database, data) => {
  data = addSectorTotals(data).map(datum => ({
    ...datum,
    sector: database.sectors[datum.sector],
    method: database.methods[datum.method]
  }));

  let publicPrivateSectorData = data.filter(datum =>
    ["Public", "Private"].includes(datum.sector)
  );

  const publicPrivateSectorMethodTotals = summarize(publicPrivateSectorData, [
    "method"
  ]).map(datum => ({
    ...datum,
    sector: "Total"
  }));

  publicPrivateSectorData = [
    ...publicPrivateSectorData,
    ...publicPrivateSectorMethodTotals
  ];

  const publicPrivateSectorSectorTotals = summarize(publicPrivateSectorData, [
    "sector"
  ]).map(datum => ({
    ...datum,
    method: "Total"
  }));

  publicPrivateSectorData = [
    ...publicPrivateSectorData,
    ...publicPrivateSectorSectorTotals
  ];

  const publicPrivateSectorMethodShare = calculateMix(
    publicPrivateSectorData,
    "sector",
    "method",
    "Total"
  );

  let privateSectorData = data.filter(datum =>
    ["Private", "Private Sub", "Private Non-Sub"].includes(datum.sector)
  );

  const privateSectorSectorTotals = summarize(privateSectorData, [
    "sector"
  ]).map(datum => ({
    ...datum,
    method: "Total"
  }));

  privateSectorData = [...privateSectorData, ...privateSectorSectorTotals];

  const privateSectorMethodShare = calculateMix(
    privateSectorData,
    "sector",
    "method",
    "Private"
  ).filter(datum => datum.sector !== "Private");

  return [...publicPrivateSectorMethodShare, ...privateSectorMethodShare].map(
    datum => ({
      ...datum,
      sector: `${datum.sector} (Share)`
    })
  );
};

const getData = (database, indicatorId, areaId) => {
  const data = database.data.filter(
    datum =>
      datum.area === areaId &&
      datum.indicator === indicatorId &&
      datum.year === 2018
  );

  return [...getMixData(database, data), ...getShareData(database, data)];
};

export default getData;
